export enum UserRole {
  KITTING = 'kitting',
  FABRIC = 'fabric',
  POWDER = 'powder',
  ASSEMBLY = 'assembly',
  KANBAN = 'kanban',
  MANAGER = 'manager',
  ADMIN = 'admin',
  USER_MANAGEMENT = 'user_management',
  ALL_LOCATIONS = 'all_locations',
  LOCATION_AUBURN_WA = 'location_auburn_wa',
  LOCATION_GRAND_PRAIRIE_TX = 'location_grand_prairie_tx'
}

export interface User {
  _id: string;
  email: string;
  roles: UserRole[];
} 